import axiosInstance from '../config/axios';

/**
 * Add bank details
 * @param {Object} bankData - { account_holder_name, bank_name, account_number, routing_number, ... }
 */
export const addBankDetailsApi = (bankData) =>
  axiosInstance.post('/bank-details', bankData).then((res) => res.data);

/**
 * Get user's bank details list
 */
export const getBankDetailsApi = () =>
  axiosInstance.get('/bank-details').then((res) => res.data);

/**
 * Get bank details by ID
 * @param {string} id
 */
export const getBankDetailsByIdApi = (id) =>
  axiosInstance.get(`/bank-details/${id}`).then((res) => res.data);

/**
 * Update bank details by ID
 * @param {string} id
 * @param {Object} bankData
 */
export const updateBankDetailsApi = (id, bankData) =>
  axiosInstance.put(`/bank-details/${id}`, bankData).then((res) => res.data);

/**
 * Delete bank account by ID
 * @param {string} id
 */
export const deleteBankAccountApi = (id) =>
  axiosInstance.delete(`/bank-details/${id}`).then((res) => res.data);

/**
 * Link or update PayPal account
 * @param {Object} data - { paypal_email }
 */
export const linkPayPalAccountApi = (data) =>
  axiosInstance.post('/link-paypal', data).then((res) => res.data);
